/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
*/

import { HttpParams } from "@angular/common/http";
import { RbuChart } from "@src/app/modules/agent/agent-dashboard-page/RbuChart";

export class RbuMyOmcChart extends RbuChart {
    title = "Request Distribution for My OMCs";
    dataParams = new HttpParams().set('week', 0).set('show', 'myomcs');
}
